/**
 * Annonsspårning — klicket in, och klicket vidare till kassan.
 *
 * BAKGRUNDEN
 * Skrevs för headless-sajten, där köpet skedde på checkout.lindasljus.se. I
 * Shopify-temat ligger kassan på /checkout, på samma domän. Shopifys Google-app lägger sin
 * konverteringstagg på kassan — men den taggen kan bara tillskriva ett köp till
 * en annons om den hittar ett gclid i Shopifys session.
 *
 * Besökaren landar på lindasljus.se. Shopify ser henne först i kassan, och då är
 * gclid:t sedan länge borta: det stod i adressen till landningssidan, på en annan
 * domän, och kassalänken bar inte med sig det. Mätkedjan gick av på två ställen.
 * Resultatet var att Google Ads hade rapporterat noll konverteringar hur mycket
 * vi än sålde — och en budgivning som optimerar mot noll släcker sig själv.
 *
 * DEN HÄR FILEN GÖR TVÅ SAKER
 *   1. Fångar klick-id:t när besökaren landar och sparar det förstapartsägt.
 *   2. Hänger på det sista biten, på länken till kassan.
 *
 * Google skickar tre sorters klick-id. gclid är det vanliga; gbraid och wbraid
 * kom när iOS började begränsa spårning och används när ett gclid inte kan
 * sättas. Bara ett av dem finns åt gången, och det som kommer sist vinner —
 * en ny annonsresa ska inte tillskrivas den förra annonsen.
 *
 * Lagringstiden är 90 dagar, samma fönster som Google Ads tillskriver inom.
 */
(function () {
  'use strict';

  var NYCKEL   = 'll_ads_klick';
  var DAGAR    = 90;
  var KLICK_ID = ['gclid', 'gbraid', 'wbraid'];
  var KAMPANJ  = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  /**
   * Får vi spara i besökarens webbläsare?
   *
   * Att minnas ett klick-id i 90 dagar är inte nödvändigt för att sajten ska
   * fungera — det är annonsmätning, och kräver samtycke i EU. Utan ja hålls
   * ingenting kvar här. Överlämningen till kassan sköts då i stället av
   * Google-taggens url_passthrough och linker, som är byggda för just det
   * läget. Se components/google-tag.php.
   */
  function farSpara() {
    try {
      return window.LLSamtycke ? window.LLSamtycke.status() === 'ja'
                               : localStorage.getItem('ll_samtycke') === 'ja';
    } catch (e) {
      return false;
    }
  }

  function las() {
    if (!farSpara()) return null;
    try {
      var r = localStorage.getItem(NYCKEL);
      if (!r) return null;
      var d = JSON.parse(r);
      // Gammalt än fönstret Google tillskriver inom är inte värt att bära med.
      if (!d || !d.t || (Date.now() - d.t) > DAGAR * 864e5) {
        localStorage.removeItem(NYCKEL);
        return null;
      }
      return d;
    } catch (e) {
      // Privat läge, blockerade kakor, full kvot. Mätningen får falla bort;
      // kassan ska fungera ändå.
      return null;
    }
  }

  function skriv(d) {
    if (!farSpara()) return;
    try { localStorage.setItem(NYCKEL, JSON.stringify(d)); } catch (e) {}
  }

  /** Plockar klick-id och kampanjparametrar ur adressen, om de står där. */
  function fanga() {
    var q = new URLSearchParams(location.search);
    var ny = null;

    for (var i = 0; i < KLICK_ID.length; i++) {
      var v = q.get(KLICK_ID[i]);
      if (v) { ny = { id: KLICK_ID[i], v: v, t: Date.now(), p: {} }; break; }
    }

    // utm utan klick-id är ett riktigt besök att minnas — ett nyhetsbrev, en
    // länk i ett inlägg. Det ska inte skriva över ett levande annonsklick.
    if (!ny && q.get('utm_source')) {
      ny = { id: null, v: null, t: Date.now(), p: {} };
    }
    if (!ny) return;

    for (var j = 0; j < KAMPANJ.length; j++) {
      var k = q.get(KAMPANJ[j]);
      if (k) ny.p[KAMPANJ[j]] = k;
    }

    var gammal = las();
    if (gammal && gammal.id && !ny.id) return; // behåll annonsklicket
    skriv(ny);
  }

  /**
   * Hänger klick-id och kampanj på en Shopify-kassaadress.
   * Rör aldrig parametrar Shopify redan satt: kassans egen nyckel står där.
   */
  function marker(url) {
    var d = las();
    if (!d || !url) return url;
    try {
      var u = new URL(url, location.origin);
      if (d.id && d.v && !u.searchParams.has(d.id)) u.searchParams.set(d.id, d.v);
      Object.keys(d.p).forEach(function (k) {
        if (!u.searchParams.has(k)) u.searchParams.set(k, d.p[k]);
      });
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  fanga();

  // cart.js sätter href på kassaknappen varje gång varukorgen ritas om, och
  // den kan rita om sig efter att den här filen körts. Att märka en gång vid
  // start räcker därför inte — vi märker i samma ögonblick som klicket sker.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href') || '';
    // I Shopify-temat ligger kassan på samma domän (/checkout). Den gamla
    // kassavärden står kvar så att länkar från andra håll också märks.
    if (h.indexOf('checkout.lindasljus.se') === -1 && !/^\/checkout(\b|\/|\?|$)/.test(h)) return;
    var m = marker(a.href);
    if (m !== a.href) a.href = m;
  }, true); // fångstfasen: vi hinner före allt annat som lyssnar på klicket

  window.LLAnnons = { marker: marker, las: las };
})();
